// French — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const fr = {
  "uploadTitle": "Ajoutez vos photos",
  "uploadHint": "Cliquez ou glissez vos images ici",
  "uploadHintTouch": "Touchez pour choisir des photos",
  "uploadOr": "ou",
  "takePhoto": "Prendre une photo",
  "yourPhotos": "Vos photos",
  "photoLabel": "Photo {n}",
  "photoCount": "{n} photos",
  "addPhoto": "Ajouter une photo",
  "continue": "Continuer",
  "stepLabel": "Étape {current} sur {total}",
  "chooseStyle": "Choisissez un style",
  "describeCustomStyle": "Décrivez votre style personnalisé",
  "uploadReferenceTitle": "Ajoutez une photo de référence",
  "uploadReferenceHint": "L’IA reproduit ses tons, matières et son ambiance — votre pièce reste identique.",
  "removeReference": "Retirer la référence",
  "cleanupOptionTidy": "Ranger",
  "cleanupOptionTidyDesc": "Les meubles restent, on enlève le désordre et les déchets",
  "cleanupOptionEmpty": "Vider la pièce",
  "cleanupOptionEmptyDesc": "Retire meubles et déco. Murs et sols restent",
  "cleanupChooseOption": "Choisissez le type de nettoyage",
  "layoutOptionFlow": "Meilleure circulation",
  "layoutOptionFlowDesc": "Des passages plus fluides — on circule plus facilement",
  "layoutOptionSpacious": "Plus spacieux",
  "layoutOptionSpaciousDesc": "Dégage les perspectives — la pièce paraît plus grande",
  "planChooseOption": "Que veux-tu créer à partir de ton plan ?",
  "planOption_3d": "Plan 3D",
  "planOption_3dDesc": "Tout le logement vu d'en haut, meublé dans le style choisi",
  "planOption_room": "Une pièce",
  "planOption_roomDesc": "Colorie une pièce sur le plan pour la voir à hauteur d'yeux",
  "planOption_clean": "Plan au propre",
  "planOption_cleanDesc": "Un croquis ou un plan flou, redessiné au propre",
  "planCleanKindTitle": "Type de dessin",
  "planCleanKind_line": "Noir et blanc",
  "planCleanKind_color": "Plan en couleur",
  "planStyleTitle": "Style",
  "planRoomTitle": "Quelle pièce ?",
  "planRoomSignIn": "Connecte-toi pour choisir une pièce sur ton plan.",
  "planRoomPaint": "Colorie la pièce sur le plan",
  "planRoomPicked": "Pièce choisie",
  "planRoomRepaint": "Recolorier",
  "planRoomClear": "Effacer",
  "planRoomNamePlaceholder": "Ou tape le nom de la pièce (ex. chambre parentale)",
  "planCropHint": "Cadre la photo sur le plan pour un résultat plus précis.",
  "planFirstOnly": "Seule la première photo est utilisée comme plan.",
  "planRoomPickTitle": "Choisis une pièce",
  "planRoomPickHint": "Colorie la pièce à visualiser. Un tracé rapide suffit.",
  "planRoomPickDone": "Utiliser cette pièce",
  "planRoomNeedPick": "Colorie une pièce sur le plan ou tape son nom.",
  "errNotFloorplan": "Ça ne ressemble pas à un plan. Importe un plan ou choisis un style.",
  "planRoomFrom": "Pièce sélectionnée sur le plan",
  "planInputLabel": "Plan",
  "planOutput_plan_3d": "Plan 3D",
  "planOutput_plan_room": "Vue de la pièce",
  "planOutput_plan_clean": "Plan au propre",
  "planOutput_plan_color": "Plan en couleur",
  "planRoomFromResult": "Voir une pièce",
  "planRoomMake": "Créer cette pièce",
  "planRoomMeta": "{n} crédits · cette pièce à hauteur d'yeux, même logement",
  "layoutChooseOption": "Choisissez le réagencement",
  "creditEarnHint": "Gagnez des crédits en vous connectant chaque jour (+1) ou en invitant des amis (+5).",
  "languageHint": "Utilisée aussi pour l’analyse du design.",
  "reuseStyle": "— Réutiliser un style passé —",
  "customPlaceholder": "Décrivez le style souhaité (ex. « chalet chaleureux aux tons bois », « minimalisme futuriste aux accents métalliques »)",
  "customStylePublicHint": "Le texte de votre style peut apparaître anonymement dans la communauté. Désactivable dans les réglages du compte.",
  "communityRankTitle": "Styles tendance",
  "communityPeople": "{n} personnes",
  "customStylesChip": "Styles personnalisés",
  "galleryRecentBadge": "À l’instant",
  "timeJustNow": "à l’instant",
  "timeAgoMin": "il y a {n} min",
  "timeAgoHour": "il y a {n} h",
  "communityViewAll": "Tout voir",
  "galleryTitle": "Styles tendance",
  "briefsLabel": "Nouveautés",
  "briefTopupKicker": "Crédits",
  "briefTopupTitle": "Pas assez de crédits pour le prochain design",
  "briefTopupLine": "Recharge gratuite demain. Tu en veux plus maintenant ? Prends un pack.",
  "briefSeasonKicker": "De saison",
  "briefSeasonTitle": "{name} est là",
  "briefSeasonLine": "Un style de saison — pour quelques semaines seulement.",
  "briefInviteKicker": "Invitation",
  "briefInviteTitle": "Invite un ami — +{n} crédits pour vous deux",
  "briefInviteLine": "Partage ton lien. Les crédits arrivent dès son inscription.",
  "galleryEmpty": "Rien de tendance pour l'instant — les styles apparaîtront au fil des créations.",
  "galleryBuiltinTitle": "Top des styles du moment",
  "galleryPopularCustom": "Styles personnalisés en vogue",
  "galleryDiscoverTitle": "Découvrir les styles personnalisés",
  "galleryShuffle": "Mélanger",
  "galleryTranslate": "Traduire",
  "galleryTranslating": "Traduction…",
  "galleryOriginal": "Texte original",
  "galleryLiveTab": "En direct",
  "galleryLiveWaiting": "En attente de nouveaux styles…",
  "galleryLiveTitle": "Utilisés en ce moment",
  "galleryRecentCustom": "Styles personnalisés récents",
  "galleryUse": "Utiliser ce style",
  "styleShareNotice": "Le texte de vos styles personnalisés peut apparaître anonymement dans la communauté.",
  "styleShareNoticeSettings": "Désactiver dans les réglages",
  "styleShareNoticeOk": "Compris",
  "communityTopTitle": "Styles personnalisés populaires",
  "communityRecentTitle": "Utilisés à l’instant",
  "communityUses": "Utilisé {n}×",
  "communityDesigns": "{n} créations",
  "communityDesignsOne": "{n} création",
  "styleShareTitle": "Partager mes styles personnalisés",
  "styleShareDesc": "Les autres peuvent découvrir et essayer le texte de vos styles. Vos photos ne sont jamais partagées.",
  "additionalRequests": "Demandes supplémentaires",
  "optional": "(facultatif)",
  "additionalPlaceholder": "Des ajouts précis pour votre design {style} ? (ex. « ajouter une table basse en bois », « accent bleu canard »)",
  "addAdditionalRequest": "+ Ajouter des demandes précises",
  "generateDesign": "Générer le design",
  "back": "Retour",
  "generatingOne": "L’IA génère votre design d’intérieur…",
  "generatingMany": "L’IA génère {n} designs cohérents pour votre pièce…",
  "generatingOneExterior": "L’IA génère votre nouvelle façade…",
  "generatingManyExterior": "L’IA génère {n} rendus extérieurs cohérents…",
  "generatingOneGarden": "L’IA génère votre nouveau jardin…",
  "generatingManyGarden": "L’IA génère {n} rendus de jardin cohérents…",
  "generationFailed": "Échec de la génération",
  "tryAgain": "Réessayer",
  "errNoInternet": "Pas de connexion Internet. Vérifiez votre réseau et réessayez.",
  "errTimeout": "L’IA a mis trop de temps à répondre. Réessayez.",
  "errTooMany": "Trop de requêtes. Patientez un instant puis réessayez.",
  "errNetwork": "Erreur réseau. Vérifiez votre connexion et réessayez.",
  "errAI": "Le service de design IA a rencontré un problème. Réessayez.",
  "errFileType": "Format non pris en charge. Importe une image JPEG, PNG ou WebP.",
  "errFileTooLarge": "Fichier trop volumineux. Importe une image de moins de 20 Mo.",
  "errPhotoRead": "Impossible de lire cette photo. Essaie avec une autre.",
  "errCameraAccess": "Impossible d'accéder à l'appareil photo. Autorise l'accès dans les Réglages.",
  "errCameraCapture": "Impossible de prendre la photo. Réessaie.",
  "errCaptionSave": "Impossible d'enregistrer la légende. Réessaie.",
  "imageUnavailable": "Image indisponible",
  "designShareText": "Découvre ce design {style} créé avec archelier",
  "altPhoto": "Photo {n}",
  "altOriginal": "Original {n}",
  "altGenerated": "Design {n}",
  "errInvalidSpace": "Impossible de reconnaître un espace. Utilisez une photo montrant une pièce — un mur et un sol ensemble, ou un angle de la pièce.",
  "pickAnotherPhoto": "Choisir une autre photo",
  "errCustomStyle": "Décrivez votre style personnalisé.",
  "errSignIn": "Échec de la connexion. Réessayez.",
  "errInsufficientCredits": "Plus de crédits. Revenez demain pour votre bonus quotidien.",
  "creditCostHint": "{n} photos utilisent {c} crédits — {p} par photo.",
  "errCreditsShort": "Il te faut {need} crédits et tu en as {have}. Retire une photo ou invite un ami pour en gagner.",
  "credits": "Crédits",
  "creditsOne": "{n} crédit",
  "creditsMany": "{n} crédits",
  "outOfCredits": "Plus de crédits",
  "creditModalTitle": "Obtenir plus de crédits",
  "creditModalDesc": "Vos crédits quotidiens reviennent demain. Il vous en faut plus avant ?",
  "creditModalWallDesc": "Voilà tes designs gratuits du jour. {n} autres reviennent demain — ou recharge maintenant pour continuer.",
  "errOutOfCreditsToday": "Tu n'as plus de crédits pour aujourd'hui. {n} designs gratuits reviennent demain — ou recharge pour continuer.",
  "lastFreeHint": "C'était ton dernier design gratuit du jour. {n} autres demain.",
  "lastFreeHintCta": "Recharger maintenant",
  "creditModalChatFree": "Discuter avec Gio, ton designer, reste gratuit.",
  "creditModalGuestTitle": "Connectez-vous pour continuer à créer",
  "creditModalGuestDesc": "La connexion vous donne des crédits gratuits chaque jour, plus la sauvegarde et le partage.",
  "creditOptionSignIn": "Se connecter et continuer",
  "creditOptionSignInDesc": "Démarrez en une seconde avec Google ou Apple",
  "creditOptionInvite": "Inviter un ami",
  "creditOptionInviteDesc": "Vous recevez chacun +{n} crédits à son inscription",
  "comingSoon": "Bientôt disponible",
  "close": "Fermer",
  "getAppTitle": "archelier",
  "getAppDesc": "Redessinez votre espace dans l’app",
  "getAppCta": "Obtenir",
  "appGateTitle": "Continuer dans l’app",
  "appGateDesc": "Créer est plus agréable dans l’app : appareil photo, designs enregistrés, résultats plus rapides.",
  "appGateCta": "Télécharger l’app",
  "appGateNotNow": "Plus tard",
  "dailyBonusHint": "Vous recevez {n} crédits gratuits chaque jour.",
  "creditsAria": "{n} crédits restants",
  "accountCreditsTitle": "Crédits",
  "creditsDailyLabel": "Quotidiens, réinitialisés à minuit",
  "creditsBonusLabel": "Bonus, sans expiration",
  "creditsResetHint": "Vous recevez {n} crédits gratuits chaque jour. Les bonus d’invitation restent jusqu’à utilisation.",
  "creditsInviteCta": "Invitez un ami pour +{n}",
  "creditsTopUpCta": "Acheter des crédits",
  "inviteMenu": "Inviter des amis",
  "profileShare": "Partager",
  "profileShareText": "Découvrez les designs de {name} sur archelier.",
  "original": "Original",
  "aiDesign": "Design IA",
  "imageGenFailed": "La génération d’image a échoué pour cette photo",
  "seeAnalysis": "Consultez l’analyse du design ci-dessous.",
  "analysisTitle": "Analyse du design d’intérieur",
  "spaceAnalysis": "Analyse de l’espace",
  "styleDescription": "Description du style",
  "colorPalette": "Palette de couleurs",
  "furnitureRec": "Meubles recommandés",
  "shopFor": "Rechercher {item}",
  "shopShort": "Acheter",
  "paintMatch": "Peinture la plus proche",
  "paintCodeCopy": "Copier le code peinture",
  "paintCodeCopied": "Code copié",
  "editRegion": "Modifier une zone",
  "editRegionTitle": "Modifie ce design",
  "editRegionDesc": "Dites à l’IA quoi changer et par quoi le remplacer. Le reste de la pièce ne bouge pas.",
  "editRegionBrushHint": "Dis à l'IA quoi changer ou ajouter. Pour cibler un endroit, peins dessus d'abord — sinon toute l'image sera modifiée. Pour supprimer un élément, peins dessus et écris « supprime-le ».",
  "editRegionMeta": "Enregistré comme nouveau design · {n} crédits",
  "editedFromBanner": "Ceci est une copie modifiée.",
  "viewOriginal": "Voir l’original",
  "editsOfThisDesign": "Modifications de ce design",
  "editsOfThisDesignDesc": "Designs créés en modifiant des parties de celui-ci.",
  "chatTitle": "Conseiller design IA",
  "chatHint": "Posez vos questions sur cette pièce. L’IA voit votre design et s’y réfère.",
  "chatStart": "Démarrer la conversation",
  "chatPlaceholder": "Un meuble, une couleur, une idée d’agencement…",
  "chatSend": "Envoyer",
  "chatSending": "Réflexion…",
  "chatSuggestion1": "Quelle lampe réchaufferait cette pièce ?",
  "chatSuggestion2": "Comment la faire paraître plus spacieuse ?",
  "chatSuggestion3": "Quelles 3 choses changer en premier ?",
  "chatTurnsRemaining": "{n} tours restants pour ce design",
  "chatTurnsExhausted": "Limite de conversation atteinte pour ce design. Créez un nouveau design pour continuer.",
  "chatErrGeneric": "Le conseiller n’a pas pu répondre. Réessayez.",
  "chatPro": "Pro — chat illimité",
  "chatRetry": "Réessayer",
  "commentsTitle": "Commentaires",
  "commentPlaceholder": "Ajouter un commentaire",
  "commentPost": "Publier",
  "commentPosting": "Publication…",
  "commentSignInHint": "Connectez-vous pour commenter.",
  "commentEmpty": "Pas encore de commentaires.",
  "commentDelete": "Supprimer",
  "commentDeleteConfirm": "Supprimer ce commentaire ?",
  "commentTooLong": "Les commentaires sont limités à 500 caractères.",
  "commentErrGeneric": "Impossible de publier le commentaire. Réessayez.",
  "commentCount": "{n}",
  "bookmarksTitle": "Mes collections",
  "tabDesigns": "Designs",
  "tabCollections": "Collections",
  "bookmarksSectionTitle": "Designs enregistrés",
  "bookmarksEmpty": "Pas encore de collections. Enregistrez un design pour créer un tableau.",
  "bookmarksAdd": "Enregistrer",
  "bookmarksAdded": "Enregistré",
  "bookmarksRemove": "Retirer des enregistrements",
  "bookmarksSignInHint": "Connectez-vous pour enregistrer des designs.",
  "saved": "Enregistré",
  "savedCollectionDefault": "Enregistrés",
  "follow": "Suivre",
  "unfollow": "Ne plus suivre",
  "following": "Abonnements",
  "followers": "Abonnés",
  "followingTab": "Abonnements",
  "followingEmpty": "Suivez des personnes pour voir leurs derniers designs ici.",
  "followersEmpty": "Pas encore d’abonnés.",
  "followingEmpty2": "Vous ne suivez personne pour le moment.",
  "followSignInHint": "Connectez-vous pour suivre",
  "cannotFollowSelf": "Vous ne pouvez pas vous suivre vous-même.",
  "profile": "Profil",
  "profileNotFound": "Ce profil n’existe pas.",
  "profileDesigns": "Designs",
  "profileDesignsCount": "Designs",
  "profileFollowers": "Abonnés",
  "profileFollowing": "Abonnements",
  "profileBio": "Bio",
  "profileEdit": "Modifier le profil",
  "profileMyProfile": "Mon profil",
  "displayNameLabel": "Nom affiché",
  "displayNamePlaceholder": "Votre nom ou studio (facultatif)",
  "displayNameSave": "Enregistrer le nom",
  "displayNameSaved": "Nom enregistré",
  "displayNameErrGeneric": "Impossible d’enregistrer le nom. Réessayez.",
  "handleLabel": "Identifiant",
  "handlePlaceholder": "minuscules, chiffres, underscore (3-20 car.)",
  "handleSave": "Enregistrer l’identifiant",
  "handleSaved": "Identifiant enregistré",
  "handleInvalid": "L’identifiant doit faire 3-20 caractères : a-z, 0-9, underscore.",
  "handleTaken": "Cet identifiant est déjà pris.",
  "handleErrGeneric": "Impossible d’enregistrer l’identifiant. Réessayez.",
  "bioPlaceholder": "Parlez un peu de vous (200 caractères max)",
  "bioSave": "Enregistrer la bio",
  "bioSaved": "Bio enregistrée",
  "bioErrGeneric": "Impossible d’enregistrer la bio. Réessayez.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "votre_identifiant_instagram",
  "instagramInvalid": "Lettres, chiffres, point ou underscore uniquement (30 max).",
  "profileNoDesigns": "Pas encore de designs.",
  "collections": "Collections",
  "collectionsTab": "Collections",
  "collectionMine": "Mes collections",
  "collectionEmpty": "Pas encore de collections.",
  "collectionPublicEmpty": "Aucune collection publique.",
  "collectionItemCount": "{n} éléments",
  "collectionEmpty2": "Cette collection est vide.",
  "newCollection": "Nouvelle collection",
  "collectionNamePlaceholder": "Nom de la collection (ex. Idées salon)",
  "collectionCreate": "Créer",
  "collectionDelete": "Supprimer la collection",
  "collectionDeleteConfirm": "Supprimer cette collection ? Les éléments seront retirés.",
  "collectionRename": "Renommer la collection",
  "collectionVisibility": "Collection publique",
  "collectionVisibilityOn": "Visible par toute personne ayant le lien",
  "collectionVisibilityOff": "Visible par vous seul",
  "addToCollection": "Ajouter à une collection",
  "saveToCollection": "Enregistrer dans une collection",
  "collectionAdded": "Ajouté",
  "collectionRemoveFromBoard": "Retirer de la collection",
  "collectionShareLink": "Copier le lien de la collection",
  "collectionByOwner": "par",
  "collectionNotFound": "Cette collection n’existe pas ou est privée.",
  "collectionErrCreate": "Impossible de créer la collection.",
  "collectionErrSave": "Impossible de mettre à jour la collection.",
  "collectionDone": "Terminé",
  "collectionPickerHint": "Touchez une collection pour ajouter ou retirer ce design.",
  "uploadAcceptsHint": "Les photos marchent le mieux, mais croquis, élévations, plans et captures 3D fonctionnent aussi.",
  "examplePhotos": "Exemples de photos",
  "detectedInputTypes": {
    "sketch": "Croquis",
    "elevation": "Élévation",
    "floorplan": "Plan",
    "3d_model": "Modèle 3D"
  },
  "floorplanDetectedBanner": "On dirait un plan — la plus grande pièce commune a été rendue à hauteur d’yeux. Pour viser une pièce précise, ajoutez une note à votre demande la prochaine fois (ex. « rendre la chambre principale »).",
  "floorplanDetectedBannerWithRoom": "On dirait un plan — {room} rendue à hauteur d’yeux. Pour une autre pièce, ajoutez une note à votre demande la prochaine fois.",
  "spaceCategoryTitle": "Que voulez-vous designer ?",
  "spaceCategories": {
    "interior": "Intérieur",
    "exterior": "Extérieur",
    "garden": "Jardin"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Citrouilles, lanternes, porche d’automne"
    },
    "christmas": {
      "name": "Noël",
      "description": "Couronnes, guirlandes lumineuses, sapin"
    },
    "lunar_new_year": {
      "name": "Nouvel An lunaire",
      "description": "Lanternes rouges, or, sentences porte-bonheur"
    },
    "spring_blossom": {
      "name": "Floraison de printemps",
      "description": "Arbres en fleurs, plantations pastel, lumière claire"
    },
    "modern_facade": {
      "name": "Façade moderne",
      "description": "Géométrie épurée, grandes baies, matériaux mixtes"
    },
    "modern_farmhouse": {
      "name": "Farmhouse moderne",
      "description": "Bardage blanc, encadrements noirs, accents bois"
    },
    "mediterranean": {
      "name": "Méditerranéen",
      "description": "Enduit, terre cuite, ouvertures en arc"
    },
    "craftsman": {
      "name": "Craftsman",
      "description": "Bardeaux bois, pignons bas, chevrons apparents"
    },
    "contemporary": {
      "name": "Contemporain",
      "description": "Lignes nettes, volumes affirmés, matériaux industriels"
    },
    "minimalist_exterior": {
      "name": "Extérieur minimaliste",
      "description": "Palette sobre, matériau unique mis en avant"
    },
    "tudor": {
      "name": "Tudor",
      "description": "Style Tudor anglais — colombages et pignons pentus"
    },
    "cape_cod": {
      "name": "Cape Cod",
      "description": "Tradition Nouvelle-Angleterre — bardeaux blancs, volets noirs"
    },
    "japanese_traditional": {
      "name": "Japonais traditionnel",
      "description": "Ossature bois type minka, toit en tuiles, engawa"
    },
    "mountain_cabin": {
      "name": "Chalet de montagne",
      "description": "A-frame en bois ou rondins, niché dans la nature"
    },
    "midcentury_exterior": {
      "name": "Extérieur mid-century",
      "description": "Modernisme années 50-60 — toit plat, grandes baies"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Champ de citrouilles, lanternes, jardin d’automne"
    },
    "christmas": {
      "name": "Noël",
      "description": "Conifères illuminés, lumières chaudes, jardin d’hiver"
    },
    "lunar_new_year": {
      "name": "Nouvel An lunaire",
      "description": "Lanternes rouges, branches fleuries, jardin"
    },
    "spring_blossom": {
      "name": "Floraison de printemps",
      "description": "Cerisiers, tulipes, vert de printemps"
    },
    "modern": {
      "name": "Jardin moderne",
      "description": "Géométrie taillée, dallage, graminées"
    },
    "mediterranean": {
      "name": "Méditerranéen",
      "description": "Gravier, olivier et lavande, poteries"
    },
    "coastal": {
      "name": "Bord de mer",
      "description": "Graminées, bois flotté, plantes salines"
    },
    "minimalist": {
      "name": "Minimaliste",
      "description": "Un matériau, une palette végétale, du vide"
    },
    "zen": {
      "name": "Jardin zen",
      "description": "Gravier ratissé, pierres, végétation épurée"
    },
    "cottage": {
      "name": "Jardin cottage",
      "description": "Romantique, plantation dense, vivaces variées"
    },
    "desert": {
      "name": "Désert / Xéropaysage",
      "description": "Résistant à la sécheresse, succulentes, gravier"
    },
    "tropical": {
      "name": "Tropical",
      "description": "Feuillage luxuriant, grandes feuilles, fleurs vives"
    },
    "english": {
      "name": "Jardin anglais",
      "description": "Pelouse soignée, haies, bordures étagées"
    }
  },
  "seasonLabel": "Saison",
  "seasons": {
    "none": "Toutes",
    "spring": "Printemps",
    "summer": "Été",
    "autumn": "Automne",
    "winter": "Hiver"
  },
  "timeOfDayLabel": "Moment de la journée",
  "timesOfDay": {
    "none": "Tous",
    "day": "Jour",
    "golden_hour": "Heure dorée",
    "night": "Nuit"
  },
  "editRegionReplacementLabel": "Que veux-tu changer ?",
  "editRegionReplacementPlaceholder": "ex. ajoute une grande statue près de l'entrée",
  "editRegionSubmit": "Générer la modification",
  "editRegionGenerating": "Génération de l’image modifiée…",
  "editRegionMaskRequired": "Peignez d’abord la zone à changer.",
  "editRegionReplacementRequired": "Dites-nous quoi y mettre.",
  "editRegionBrush": "Pinceau",
  "editRegionUndo": "Annuler",
  "editRegionSize": "Taille",
  "editRegionClear": "Réinitialiser",
  "errEditGeneric": "Échec de la modification. Réessayez.",
  "lightingPlan": "Plan d’éclairage",
  "designTips": "Conseils design",
  "startNew": "Nouveau design",
  "viewMyDesigns": "Voir mes designs",
  "favorite": "Favori",
  "unfavorite": "Retirer des favoris",
  "rename": "Renommer",
  "savePromptText": "Connectez-vous pour garder ce design, le partager et en créer d’autres",
  "guestCreditsLeft": "Plus que {n} design gratuit. Connectez-vous et démarrez avec {total}.",
  "guestCreditsGone": "C’était votre dernier design gratuit. Connectez-vous et recevez-en {total}.",
  "signInGoogle": "Se connecter avec Google",
  "signInApple": "Se connecter avec Apple",
  "signInDesc": "Sauvegardez vos designs et retrouvez-les à tout moment.",
  "signInPopupBlocked": "Popup bloquée. Autorisez les popups dans les réglages du navigateur.",
  "appName": "archelier",
  "navCreate": "Créer",
  "navGallery": "Galerie",
  "navGio": "Designer",
  "navMain": "Navigation principale",
  "packsTitle": "Recharger",
  "packDesigns": "environ {n} designs",
  "packBuying": "Ouverture…",
  "packWaiting": "Paiement effectué — ajout de tes crédits…",
  "packDone": "Crédits ajoutés.",
  "packSlow": "Tes crédits arrivent. Ils s'afficheront dans un instant — inutile de racheter.",
  "packFailed": "L'achat n'a pas abouti. Si tu as été débité sans recevoir tes crédits, contacte le support.",
  "gioRole": "Designer d'espace",
  "gioAiNote": "IA",
  "gioSignInBody": "Connecte-toi pour parler avec Gio. Gio analyse les photos de tes pièces et tes anciens designs, te propose des styles et peut créer ou modifier un design directement depuis le chat.",
  "gioGreeting": "Salut, moi c'est Gio. Envoie-moi une photo de ta pièce, une image ou un lien d'une pièce qui te plaît, ou l'un de tes designs — je te proposerai une idée et pourrai la réaliser pour toi.",
  "gioChipTaste": "Quel est mon style ?",
  "gioChipTrend": "C'est quoi la tendance cette semaine ?",
  "gioChipPhoto": "Envoyer une photo de pièce",
  "gioChipMine": "Importer un de mes designs",
  "gioTyping": "Gio réfléchit…",
  "gioPlaceholder": "Demande à Gio ou colle un lien",
  "gioSend": "Envoyer",
  "gioAttachPhoto": "Joindre une photo",
  "gioPickDesign": "Mes designs",
  "gioPickEmpty": "Pas encore de design — crée-en un d'abord, puis importe-le ici.",
  "gioRemove": "Supprimer",
  "gioToday": "Aujourd'hui",
  "gioNoCredits": "Tu n'as plus de crédits.",
  "gioError": "Gio n'a pas pu répondre pour l'instant. Réessaie.",
  "gioAlreadyStarting": "C'est déjà en cours — un instant.",
  "gioPhotoSkipped": "Certaines photos n'ont pas pu être ajoutées. Tu peux ajouter jusqu'à {n} photos (JPG, PNG, WebP ou HEIC, moins de 20 Mo).",
  "gioErrPhotos": "Impossible de trouver ces photos. Ajoute une photo de ton espace et réessaie.",
  "gioErrPrompt": "Gio n'a pas pu transformer ça en design. Essaye de le décrire un peu différemment.",
  "gioErrGone": "Ce design ou cette suggestion n'est plus disponible.",
  "gioCreditsLow": "{n} crédits restants · un message coûte {c}, {p} avec une photo",
  "gioCreditsLowFree": "{n} crédits restants · discuter avec Gio est gratuit",
  "gioNoCreditsChatFree": "Tu n'as plus de crédits pour les designs — discuter reste gratuit.",
  "gioDailyLimit": "On a beaucoup discuté aujourd'hui. On continue demain.",
  "gioCardEdit": "Modifier",
  "gioCardPhotos": "Photos prêtes : {n}",
  "gioCardPhotoFromDesign": "Photo de ton projet du {date}",
  "gioCardPhotoFromDesignNoDate": "Photo de l'un de tes projets",
  "gioCardPhotoFromChat": "Photo partagée ici",
  "gioCardPhotoNew": "Nouvelle photo",
  "gioCardNoPhoto": "Pas encore de photo",
  "gioCardChangePhoto": "Changer",
  "gioCardAddPhoto": "Ajouter une photo",
  "gioCardUploading": "Importation…",
  "gioCardSame": "Tu as déjà un projet {style} pour cette photo ({date}).",
  "gioCardSameView": "Le voir",
  "gioCardSameHint": "Avec la même demande, le résultat sera très similaire. Pour changer, ajoute une demande ci-dessus, dis-le à Gio dans le chat ou ouvre-le dans Créer.",
  "gioPickPhoto": "Choisir une photo",
  "gioPickUpload": "Importer une nouvelle photo",
  "gioRunEdit": "Modifier · {n} crédits",
  "gioRunGenerate": "Créer · {n} crédits",
  "gioRunWithPhoto": "Ajouter une photo & créer · {n}/photo",
  "gioOpenInCreate": "Ouvrir dans Créer",
  "gioPaintMyself": "Peindre la zone moi-même",
  "gioStarting": "Lancement…",
  "gioJobMaking": "Création de ton design…",
  "gioJobEditing": "Modification de ton design…",
  "gioJobNotify": "Tu peux quitter — je te préviendrai quand ce sera prêt.",
  "gioJobInvalid": "Cette photo ne ressemble pas à une pièce que je peux aménager.",
  "gioJobFailed": "Je n'ai pas pu terminer ce design.",
  "gioJobRefunded": "Tes crédits t'ont été restitués.",
  "gioJobDone": "C'est prêt — jette un œil",
  "gioJobGone": "Ce design a été supprimé.",
  "gioAskAboutDesign": "Demander à Gio à propos de ce design",
  "navFeed": "Fil",
  "navMy": "Moi",
  "navAccount": "Réglages",
  "signIn": "Connexion",
  "signOut": "Déconnexion",
  "deleteAccount": "Supprimer le compte",
  "deleteAccountTitle": "Supprimer votre compte ?",
  "deleteAccountWarn": "Cela supprime définitivement votre compte et toutes les données liées. Action irréversible.",
  "deleteAccountItem_designs": "Tous vos designs, images et conversations avec Gio",
  "deleteAccountItem_profile": "Votre profil, identifiant et styles enregistrés",
  "deleteAccountItem_social": "Commentaires, likes, abonnements et collections",
  "deleteAccountItem_credits": "Vos crédits restants, y compris ceux achetés, et votre historique d’abonnement",
  "deleteAccountBilling_web": "Votre abonnement web actif sera annulé automatiquement.",
  "deleteAccountBilling_ios": "Votre abonnement App Store ou Google Play ne sera pas annulé automatiquement — annulez-le dans les réglages d’abonnement de votre store.",
  "deleteAccountFinal": "Vous serez déconnecté immédiatement, sans possibilité de récupérer ce compte.",
  "deleteAccountConfirm": "Supprimer le compte",
  "deleteAccountSubmitting": "Suppression…",
  "deleteAccountError": "Impossible de supprimer le compte. Réessayez.",
  "myDesigns": "Mes designs",
  "language": "Langue",
  "support": "Assistance",
  "terms": "Conditions d’utilisation",
  "privacy": "Politique de confidentialité",
  "signInTerms": "En vous connectant, vous acceptez nos {terms} et notre {privacy}.",
  "onboardingSkip": "Passer",
  "onboardingNext": "Suivant",
  "onboardingStart": "Commencer",
  "tourTitle": "Visite de archelier",
  "tourCreate": "Commence ici. Prends ou importe une pièce, un extérieur ou un jardin, choisis un style et obtiens ton nouveau design quelques instants plus tard.",
  "tourGallery": "Galerie — les styles les plus choisis sur archelier cette semaine. Appuie sur l'un d'eux pour l'essayer dans ton espace.",
  "tourGio": "Gio est ton designer. Montre une photo et dis ce que tu veux — Gio te suggère des styles, puis crée ou modifie le design pour toi.",
  "tourMy": "Retrouve tes projets dans Mes designs. Modifie une zone au pinceau ou en la décrivant, puis télécharge ou partage.",
  "tourStart": "Reviens sur ce bouton à tout moment pour un nouveau design. Commençons avec une photo.",
  "tourReplay": "Revoir la visite",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Photographiez, esquissez, importez",
      "desc": "Une photo de téléphone suffit, mais archelier lit aussi les croquis à main levée, élévations, plans vus de dessus et captures de modèles 3D — détection automatique."
    },
    {
      "icon": "style",
      "title": "19+ styles, 4 modes intelligents",
      "desc": "Choisissez un style prédéfini, écrivez un prompt personnalisé, imitez une photo de référence, ou utilisez les modes Rangement / Agencement."
    },
    {
      "icon": "brush",
      "title": "Modifiez juste la partie voulue",
      "desc": "Un coin vous déplaît ? Peignez-le sur le résultat et dites à l’IA quoi y mettre. Le reste de la pièce reste identique au pixel près."
    },
    {
      "icon": "auto_awesome",
      "title": "Essayez maintenant",
      "desc": "Des crédits gratuits chaque jour. Importez une photo : votre premier design est prêt en une minute environ."
    }
  ],
  "onboardTabFeedTitle": "Explorez d’abord",
  "onboardTabFeedDesc": "Voyez ce que les autres ont créé et trouvez l’inspiration pour votre espace.",
  "onboardTabCreateTitle": "Designez avec l’IA",
  "onboardTabCreateDesc": "Importez une photo, un croquis ou un plan — l’IA génère un nouveau design.",
  "onboardTabMyTitle": "Sauvegardez et gérez",
  "onboardTabMyDesc": "Vos designs se rassemblent ici. Partagez ou téléchargez à tout moment.",
  "onboardTabGioTitle": "Demander à Gio",
  "onboardTabGioDesc": "Gio, notre designer d'espace, te suggère des styles d'après tes photos et peut créer ou modifier des designs directement dans le chat.",
  "myDesignsTitle": "Mes designs",
  "signInToSee": "Connectez-vous pour voir vos designs",
  "signInToSeeDesc": "Vos designs sauvegardés apparaîtront ici.",
  "loadingDesigns": "Chargement des designs…",
  "errLoadDesigns": "Échec du chargement. Réessayez.",
  "retry": "Réessayer",
  "noFavorites": "Pas encore de favoris.",
  "noDesigns": "Pas encore de designs. Créez le premier !",
  "createDesign": "Créer un design",
  "loadMore": "Voir plus",
  "loading": "Chargement…",
  "errDesignNotFound": "Design introuvable.",
  "errLoadDesign": "Échec du chargement du design.",
  "errDeleteDesign": "Échec de la suppression. Réessayez.",
  "renameTitle": "Renommer le design",
  "renamePlaceholders": [
    "Salon v1",
    "Cuisine — version claire",
    "Rénovation de l'atelier",
    "Chambre, tons chauds",
    "Balcon plan B",
    "Bureau à domicile",
    "Brouillon de café",
    "Jardin de devant v2"
  ],
  "save": "Enregistrer",
  "cancel": "Annuler",
  "deleteTitle": "Supprimer le design ?",
  "deleteDesc": "Supprime définitivement ce design et toutes ses images. Irréversible.",
  "delete": "Supprimer",
  "deleting": "Suppression…",
  "postToFeed": "Publier dans le fil",
  "postedToFeedTitle": "Publié dans le fil",
  "postedToFeedDesc": "Les autres utilisateurs peuvent maintenant voir et aimer ce design.",
  "captionTitle": "Ajouter une légende",
  "captionPlaceholder": "Racontez pourquoi vous avez repensé cet espace (facultatif)",
  "captionEdit": "Modifier la légende",
  "captionPost": "Publier",
  "captionSave": "Enregistrer",
  "captionCancel": "Annuler",
  "viewFeed": "Voir le fil",
  "generationInProgress": "Design de votre espace en cours…",
  "generationKeepBrowsing": "Continuez à naviguer — on vous prévient quand c’est prêt",
  "generationDone": "Votre design est prêt !",
  "generationTapToOpen": "Touchez Ouvrir pour le voir",
  "generationFailedHint": "Votre crédit n’a pas été débité. Réessayez.",
  "open": "Ouvrir",
  "copy": "Copier",
  "copied": "Copié !",
  "share": "Partager",
  "downloadImages": "Télécharger les images IA",
  "download": "Télécharger",
  "downloadWatermarkHint": "Une petite signature archelier figure en bas à droite.",
  "modes": {
    "redesign": "Redesign",
    "staging": "Staging de pièce vide"
  },
  "styleUsed": "Style utilisé",
  "customDescLabel": "Description personnalisée :",
  "additionalReqLabel": "Demandes supplémentaires :",
  "useStyleAgain": "Réutiliser ce style",
  "feedTitle": "Communauté",
  "feedEmpty": "Pas encore de designs publics. Soyez le premier !",
  "feedSortLatest": "Récents",
  "feedSortPopular": "Populaires",
  "feedFilterAll": "Tous",
  "useThisStyle": "Essayer ce style",
  "sourceDesignBanner": "D’après « {name} »",
  "galleryPickBanner": "Création avec {name}",
  "signInToLike": "Connectez-vous pour aimer des designs",
  "tryApp": "Essayer archelier",
  "privateTitle": "Ce design est privé",
  "privateDesc": "Le propriétaire n’a pas rendu ce design public.",
  "linkNotFoundTitle": "Ce lien n'est pas disponible",
  "linkNotFoundDesc": "Le design a peut-être été supprimé, ou le lien est incomplet.",
  "createWithApp": "Créer avec archelier",
  "shareViewCTA": "Envie de repenser votre propre espace ?",
  "styles": {
    "modern": {
      "name": "Moderne",
      "description": "Lignes épurées, tons neutres, contemporain minimaliste"
    },
    "scandinavian": {
      "name": "Scandinave",
      "description": "Lumineux, matériaux naturels, chaleur nordique"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Fonctionnel, abordable, design scandinave du quotidien"
    },
    "japandi": {
      "name": "Japandi",
      "description": "Minimalisme japonais et chaleur scandinave"
    },
    "industrial": {
      "name": "Industriel",
      "description": "Matériaux bruts, éléments apparents, esprit loft urbain"
    },
    "coastal": {
      "name": "Bord de mer",
      "description": "Élégance de maison de plage, aérée et lumineuse"
    },
    "classic": {
      "name": "Classique",
      "description": "Élégance intemporelle, tissus riches, détails ornés"
    },
    "artdeco": {
      "name": "Art déco",
      "description": "Géométrie affirmée, accents dorés, faste des années 20"
    },
    "midcentury": {
      "name": "Mid-Century Modern",
      "description": "Formes organiques, bois chaud, charme rétro 1950-60"
    },
    "maximalist": {
      "name": "Maximaliste",
      "description": "Motifs audacieux, superpositions riches, toujours plus"
    },
    "vintage": {
      "name": "Vintage",
      "description": "Charme nostalgique, trouvailles anciennes, palette rétro"
    },
    "bohemian": {
      "name": "Bohème",
      "description": "Esprit libre, textiles colorés, éclectisme artistique"
    },
    "tropical": {
      "name": "Tropical",
      "description": "Verdure luxuriante, rotin, esprit resort"
    },
    "cottagecore": {
      "name": "Cottagecore",
      "description": "Campagne anglaise romantique, fleurs, pastels doux"
    },
    "rustic": {
      "name": "Rustique",
      "description": "Bois patiné, pierre, charme de ferme chaleureux"
    },
    "wabisabi": {
      "name": "Wabi-sabi",
      "description": "Beauté imparfaite, textures brutes, ascèse japonaise"
    },
    "gothic": {
      "name": "Gothique",
      "description": "Drame sombre, velours, silhouettes ornées"
    },
    "cyberpunk": {
      "name": "Cyberpunk",
      "description": "Futurisme néon, surfaces hi-tech, dystopie urbaine"
    },
    "taisho_romance": {
      "name": "Taishō Romance",
      "description": "Japon du début XXe rencontre l’Art nouveau occidental"
    },
    "biophilic": {
      "name": "Biophilique",
      "description": "Plantes partout, lumière naturelle, textures organiques"
    },
    "cozy": {
      "name": "Cocooning",
      "description": "Chaleureux, doux, accueillant — confort hygge"
    },
    "gaming": {
      "name": "Gaming",
      "description": "Setup RGB, tech élégante, battlestation immersive"
    },
    "minimalist": {
      "name": "Minimaliste",
      "description": "Épuré, sans encombrement, espaces vides"
    },
    "mediterranean": {
      "name": "Méditerranéen",
      "description": "Badigeon, terre cuite, arches, pierre"
    },
    "luxury": {
      "name": "Luxe discret",
      "description": "Matériaux nobles, palette sobre"
    },
    "dark_academia": {
      "name": "Dark Academia",
      "description": "Bibliothèque sombre — bordeaux, laiton, livres"
    },
    "organic_modern": {
      "name": "Moderne organique",
      "description": "Formes modernes, matières brutes"
    },
    "farmhouse": {
      "name": "Farmhouse",
      "description": "Lambris, évier tablier, bois patiné"
    },
    "halloween": {
      "name": "Halloween",
      "description": "Citrouilles, bougies, automne sombre"
    },
    "christmas": {
      "name": "Noël",
      "description": "Sapin, guirlandes, lumières chaudes"
    },
    "lunar_new_year": {
      "name": "Nouvel An lunaire",
      "description": "Rouge et or, lanternes, motifs porte-bonheur"
    },
    "spring_blossom": {
      "name": "Floraison de printemps",
      "description": "Cerisiers, pastels, lumière claire"
    },
    "custom": {
      "name": "Style personnalisé",
      "description": "Décrivez votre propre vision d’intérieur"
    },
    "reference": {
      "name": "Référence",
      "description": "Reproduit les tons, matières et l’ambiance d’une photo"
    },
    "floorplan": {
      "name": "Plan",
      "description": "Un plan 3D ou un dessin au propre d'après ton plan"
    },
    "cleanup": {
      "name": "Rangement",
      "description": "Ranger le désordre ou vider la pièce — au choix"
    },
    "layout": {
      "name": "Agencement",
      "description": "Mêmes meubles, meilleur placement — circulation ou espace"
    }
  },
  "langMismatchNotice": "Cette analyse a été générée en {lang}.",
  "pricingTitle": "Des formules qui évoluent avec vous",
  "pricingSubtitle": "Commencez gratuitement. Passez au niveau supérieur quand il vous faut plus.",
  "pricePerMonth": "/ mois",
  "trialCta": "Essai gratuit de {n} jours",
  "accountPlanFreeTitle": "Votre compte est GRATUIT",
  "accountPlanProTitle": "Vous êtes sur Pro",
  "accountPlanTrialTitle": "Vous êtes sur Pro — essai gratuit",
  "proTrialBadge": "Essai",
  "proTrialDaysLeft": "{n} jours restants dans votre essai gratuit",
  "proTrialIntroTitle": "2 semaines de Pro — gratuites",
  "proTrialIntroDesc": "Inscrivez-vous et démarrez avec {n} crédits gratuits.",
  "proTrialFeatures": "Puis {n} de plus chaque jour. Sans abonnement, jamais.",
  "welcomeSkip": "Continuer sans compte",
  "landingHeadline": "repensez chaque pièce, en quelques secondes.",
  "landingTagline": "Une photo, un style, un rendu photoréaliste. Gratuit chaque jour, sans abonnement.",
  "landingOpenWeb": "Ou continuer sur le web →",
  "landingFeat1": "Rendus d’intérieur IA",
  "landingFeat2": "Photoréaliste",
  "landingFeat3": "50+ styles",
  "landingFeat4": "Jardin & extérieur",
  "landingFeat5": "Gratuit chaque jour",
  "landingStoreOn": "Télécharger sur l’",
  "landingStoreGet": "Disponible sur",
  "lp": {
    "metaTitle": "archelier — Design d’intérieur IA à partir d’une photo, croquis ou plan",
    "metaDescription": "Prends n’importe quelle pièce en photo et obtiens un rendu photoréaliste en une minute. 48 styles pour l’intérieur, l’extérieur et le jardin, plans 3D, retouches au pinceau et un designer IA avec qui discuter. Gratuit tous les jours.",
    "heroEyebrow": "Design d’intérieur par IA",
    "scrollCue": "Découvrir le fonctionnement",
    "webCta": "Essaie gratuitement dans ton navigateur",
    "orApp": "Ou télécharge l'application",
    "qrHint": "Scanne avec l'appareil photo de ton téléphone. L'application te prévient dès que ton design est prêt.",
    "showEyebrow": "Avant & après",
    "showTitle": "Une photo. Une toute nouvelle pièce.",
    "showBody": "Résultats réels créés avec archelier. Fais glisser pour comparer.",
    "before": "Avant",
    "after": "Après",
    "tabRoom": "Salon",
    "tabEmpty": "Pièce vide",
    "tabSketch": "Croquis",
    "tabPlan": "Plan",
    "tabExterior": "Extérieur",
    "capRoom": "Rustique — la même cuisine et pièce de vie, en plus chaleureux.",
    "capEmpty": "Scandinave — une pièce vide, meublée.",
    "capSketch": "Japandi — un simple croquis rendu comme un vrai espace.",
    "capPlan": "Mode plan — un plan 2D transformé en vue 3D de toute la maison.",
    "capExterior": "Minimaliste — une devanture chargée, entièrement repensée.",
    "howEyebrow": "Comment ça marche",
    "howTitle": "Trois étapes, environ une minute.",
    "how1Title": "Prends une photo",
    "how1Body": "N’importe quelle pièce telle qu’elle est — ou un croquis, un plan, une capture 3D. Jusqu’à 3 angles d’une même pièce.",
    "how2Title": "Choisis un style",
    "how2Body": "Choisis parmi 48 styles, décris le tien en une sentence ou importe la photo d’un style que tu adores.",
    "how3Title": "Obtiens ton projet",
    "how3Body": "Un rendu photoréaliste de ton espace, avec liste de meubles, palette de couleurs et plan d’éclairage.",
    "stylesEyebrow": "Styles",
    "stylesTitle": "48 styles, trois types d’espaces.",
    "stylesBody": "28 pour l’intérieur, 11 pour l’extérieur, 9 pour le jardin — plus des looks de saison pour Halloween, Noël, le Nouvel An lunaire et le printemps.",
    "stylesInterior": "Intérieur",
    "stylesExterior": "Extérieur",
    "stylesGarden": "Jardin",
    "stylesCta": "Parcourir la galerie de styles",
    "modesEyebrow": "Au-delà des styles",
    "modesTitle": "Cinq autres façons de repenser un espace.",
    "modeCustomTitle": "Style personnalisé",
    "modeCustomBody": "Décris le style voulu en une phrase et enregistre-le pour la prochaine fois.",
    "modeReferenceTitle": "Image de référence",
    "modeReferenceBody": "Importe une photo inspirante pour en reprendre le ton, les matériaux et la palette — sans changer ton agencement.",
    "modeCleanupTitle": "Désencombrement",
    "modeCleanupBody": "Fais le vide pour voir la pièce entièrement nue.",
    "modeLayoutTitle": "Agencement",
    "modeLayoutBody": "Réagence les meubles déjà présents sans les remplacer.",
    "modePlanTitle": "Plan 2D / 3D",
    "modePlanBody": "Transforme un plan 2D en vue 3D de toute la maison, ou un croquis rapide en dessin propre.",
    "editEyebrow": "Retouche au pinceau",
    "editTitle": "Modifie un élément à la fois.",
    "editBody": "Pas convaincu par le canapé ? Entoure-le et écris ce que tu souhaites à la place. archelier modifie uniquement cette zone sans toucher au reste — valable aussi pour la peinture, les tapis, l’éclairage ou les tableaux.",
    "editPrompt": "Un canapé en cuir vintage",
    "shopTitle": "Retrouve les produits.",
    "shopBody": "Chaque projet inclut la liste des meubles, la palette de couleurs et le plan d’éclairage, avec des liens pour trouver des articles similaires.",
    "gioEyebrow": "Gio",
    "gioTitle": "Échange avec un designer.",
    "gioBody": "Gio est ton designer d’espace IA, accessible dans son propre onglet. Envoie la photo de ta pièce, un lien ou une image coup de cœur, ou l’un de tes projets. Gio te propose une direction et crée ou modifie le projet directement dans le chat.",
    "gioRole": "Designer d’espace",
    "gioUser": "Voici ma cuisine et mon coin repas. C’est un peu froid. Des idées ?",
    "gioReply": "Misons sur du bois chaleureux, des textiles doux et une lumière d’ambiance tamisée. Voici une piste à essayer :",
    "gioCardTitle": "Chaleur Japandi",
    "gioCardBody": "Le chêne naturel et l’enduit texturé apportent instantanément de la chaleur à la pièce.",
    "gioCardAction": "Générer",
    "priceEyebrow": "Tarifs",
    "priceTitle": "Gratuit chaque jour. Sans abonnement.",
    "price1": "Des designs gratuits chaque jour, réinitialisés à minuit",
    "price2": "Un bonus quand tu crées un compte",
    "price3": "Invite un ami et vous en obtenez plus tous les deux",
    "price4": "Besoin de plus ? Recharge avec un pack de crédits",
    "privacyTitle": "Tes photos t'appartiennent.",
    "privacyBody": "Tes photos, prompts et designs ne sont jamais utilisés pour entraîner des modèles IA ou pour la publicité. Tes designs restent privés sauf si tu les partages.",
    "faqTitle": "Questions",
    "faq1Q": "Qu'est-ce qu'archelier ?",
    "faq1A": "archelier (Architecte + Atelier) est une application de design d'intérieur IA sur mobile et web. Oriente ta caméra vers une pièce, choisis un style et obtiens un rendu photoréaliste de ton espace, avec chaque meuble identifié et lié. Fonctionne pour l'intérieur, l'extérieur et le jardin.",
    "faq2Q": "Comment ça marche ?",
    "faq2A": "Prends une photo de la pièce ou importe un croquis, un plan ou une capture 3D. Choisis parmi 48 styles, décris le tien ou importe une photo de référence. En une minute environ, tu obtiens un rendu photoréaliste de ton espace, une liste de meubles, une palette de couleurs et un plan d'éclairage.",
    "faq3Q": "Est-ce qu'archelier est gratuit ?",
    "faq3A": "Oui. Sans abonnement. Tout le monde reçoit des designs gratuits chaque jour, réinitialisés à minuit, plus un bonus à la création de compte et à l'invitation d'un ami. Si tu en veux plus, tu peux acheter un pack de crédits.",
    "faq4Q": "Peut-on transformer un plan en rendu 3D ?",
    "faq4A": "Oui. Le mode Plan transforme un plan 2D en vue 3D de tout le logement dans le style choisi. Il peut aussi convertir un croquis ou un plan flou en dessin propre ou en plan coloré.",
    "faq5Q": "Puis-je reproduire le style d'une photo que j'aime ?",
    "faq5A": "Oui. Choisis le style Référence et importe ta photo d'inspiration. archelier en reprend l'ambiance, les matériaux et la palette pour les appliquer à ta pièce sans en copier l'agencement.",
    "faq6Q": "Puis-je modifier une seule partie d'un design ?",
    "faq6A": "Oui. Entoure la zone à modifier — le canapé, le tapis, un mur — et écris ce que tu souhaites à la place. Seule cette zone est modifiée ; le reste de la pièce ne change pas.",
    "faq7Q": "Qui est Gio ?",
    "faq7A": "Gio est le designer d'espace IA d'archelier. Envoie-lui une photo de ta pièce, d'un espace que tu aimes ou l'un de tes designs. Gio te propose une direction, crée ou modifie le design dans le chat et répond à tes questions sur les couleurs, le budget et l'éclairage.",
    "faq8Q": "Mes photos servent-elles à entraîner l'IA ?",
    "faq8A": "Non. archelier n'utilise ni tes photos, ni tes prompts, ni tes designs pour entraîner des modèles IA ou pour la publicité. Tes designs restent privés sur ton compte sauf si tu les partages.",
    "faq9Q": "Où puis-je utiliser archelier ?",
    "faq9A": "Sur l'App Store, Google Play et le web sur archelier.co. Ton compte et tes designs se synchronisent partout. archelier est disponible en 11 langues.",
    "ctaTitle": "Réinvente ta pièce aujourd'hui.",
    "ctaBody": "Sur mobile et sur le web. Tes designs se synchronisent partout.",
    "langLabel": "Langue"
  },
  "upgradeToPro": "Passer à Pro",
  "creditsPerMonth": "{n} crédits par mois",
  "planFreeName": "Gratuit",
  "planFreeTagline": "Essayez archelier avec quelques designs par mois.",
  "planProName": "Pro",
  "planProTagline": "Pour les designers réguliers qui veulent de la qualité.",
  "planStudioName": "Studio",
  "planStudioTagline": "Pour les utilisateurs intensifs, équipes et usage commercial.",
  "planFeatWatermark": "Inclut le filigrane « archelier »",
  "planFeatNoWatermark": "Aucun filigrane sur les designs enregistrés ou partagés",
  "planFeatUnlimited": "Générations de designs IA illimitées",
  "planFeatUnlimitedChat": "Chat IA illimité par design (gratuit : 3 tours)",
  "planFeatUnlimitedEdit": "Modifications de zones illimitées",
  "planFeatFeed": "Partage dans le fil",
  "planFeatEverythingPro": "Tout ce qui est inclus dans Pro",
  "planFeatCommercial": "Droits d’usage commercial",
  "planFeatApiAccess": "Accès API (bientôt)",
  "planCtaSubscribe": "S’abonner",
  "planCtaCurrent": "Votre formule actuelle",
  "planPopular": "La plus populaire",
  "signInToSubscribe": "Connectez-vous pour vous abonner",
  "signInToBuy": "Connectez-vous pour acheter",
  "trialNote": "Essai gratuit de {n} jours",
  "creditPacksTitle": "Ou rechargez avec des packs de crédits",
  "creditPacksSubtitle": "Achat unique, sans abonnement.",
  "packStarterName": "Pack Starter",
  "packStandardName": "Pack Standard",
  "packProName": "Pack Pro",
  "packCreditsAmount": "{n} crédits",
  "packCtaBuy": "Acheter",
  "pricingFootnote": "Prix en USD. Taxes calculées au paiement. Annulable à tout moment.",
  "errBillingGeneric": "Un problème est survenu. Réessayez.",
  "accountTitle": "Réglages",
  "accountPlanSection": "Abonnement",
  "accountCreditsSection": "Crédits",
  "accountCreditsDesc": "Les crédits sont consommés à la génération. Rechargez à tout moment.",
  "viewPlans": "Voir les formules",
  "changePlan": "Changer de formule",
  "manageBilling": "Gérer la facturation",
  "manageBillingWebHint": "Si vous êtes abonné via le web, gérez-le sur archelier.co.",
  "buyCreditPack": "Acheter un pack de crédits",
  "subRenewsAt": "Renouvellement le {date}",
  "subEndsAt": "Fin le {date}",
  "trialEndsAt": "L’essai gratuit se termine le {date} — bascule auto à 9,99 $/mois",
  "trialCancelEndsAt": "L’essai se termine le {date} — l’abonnement ne sera pas renouvelé",
  "subStatus_past_due": "Paiement en retard — mettez à jour votre moyen de paiement.",
  "subStatus_canceled": "Abonnement annulé.",
  "subStatus_unpaid": "Abonnement impayé.",
  "subStatus_trialing": "Essai gratuit actif.",
  "account": "Compte",
  "pricing": "Tarifs",
  "upgrade": "Améliorer",
  "inviteTitle": "Invitez des amis, gagnez des crédits",
  "inviteSubtitle": "Quand un ami s’inscrit via votre lien, vous recevez +{inviter} crédits et lui +{invitee}.",
  "inviteFriends": "Inviter des amis",
  "inviteSignInHint": "Connectez-vous pour obtenir votre lien d’invitation.",
  "yourReferralCode": "Votre lien d’invitation",
  "inviteCodeLoading": "Préparation de votre lien…",
  "inviteLinkHint": "Les inscriptions via votre lien reçoivent +{n} crédits de départ.",
  "copyLink": "Copier le lien",
  "shareLink": "Partager le lien",
  "inviteShareText": "Repensez votre espace avec l’IA sur archelier. Mon lien vous donne +{n} crédits gratuits.",
  "redeemTitle": "Vous avez un code ?",
  "redeemDesc": "Saisissez un code d’invitation ou un code promo pour recevoir des crédits bonus.",
  "copyCode": "Copier le code",
  "errRefSelf": "Vous ne pouvez pas utiliser votre propre code.",
  "landingInviteTitle": "Un ami vous a invité — vous recevez chacun +{n} crédits.",
  "landingInviteAutoIos": "Installe l'application, puis réappuie sur ce lien d'invitation — l'application s'ouvre et ton bonus est ajouté dès ton inscription.",
  "landingInviteAutoAndroid": "Installe l'application via le bouton Google Play ci-dessous et inscris-toi — ton bonus est ajouté automatiquement. Sinon, saisis ce code dans Réglages → Inviter des amis.",
  "landingInviteDesktop": "Inscris-toi ici et ton bonus est ajouté directement. Pour l'obtenir sur l'application, scanne le QR code et suis les instructions sur ton téléphone.",
  "promoTitle": "Un code promo ?",
  "promoDesc": "Saisissez un code promo pour recevoir des crédits bonus.",
  "promoPlaceholder": "ex. LAUNCH2026",
  "promoRedeem": "Valider",
  "promoSuccess": "Validé — {n} crédits ajoutés à votre compte.",
  "errPromoInvalid": "Ce code est invalide.",
  "errPromoExpired": "Ce code a expiré.",
  "errPromoMaxed": "Ce code a atteint sa limite d’utilisation.",
  "errPromoUsed": "Vous avez déjà utilisé ce code.",
  "errPromoUserInit": "Rechargez la page et réessayez.",
  "errPromoGeneric": "Impossible de valider ce code. Réessayez.",
  "reportThisDesign": "Signaler ce design",
  "reportShort": "Signaler",
  "reportTitle": "Signaler le design",
  "reportDesc": "Quel est le problème ? Seuls les modérateurs voient votre signalement.",
  "reportReason_spam": "Spam ou publicité",
  "reportReason_nsfw": "Contenu sexuel ou inapproprié",
  "reportReason_copyright": "Violation de droits d’auteur",
  "reportReason_other": "Autre",
  "reportNotePlaceholder": "Détails (facultatif, 500 caractères max)",
  "reportSubmit": "Envoyer le signalement",
  "reportSubmitting": "Envoi…",
  "reportSignInHint": "Connectez-vous pour signaler.",
  "reportThanks": "Signalement reçu",
  "reportThanksDesc": "Nous allons vérifier et agir si nécessaire. Merci.",
  "errReportGeneric": "Impossible d’envoyer le signalement. Réessayez dans un instant.",
  "blockUser": "Bloquer cet utilisateur",
  "unblockUser": "Débloquer",
  "blockShort": "Bloquer",
  "blockConfirm": "Bloquer @{handle} ? Vous ne verrez plus ses designs et il ne pourra plus interagir avec les vôtres.",
  "blockedUsersMenu": "Utilisateurs bloqués",
  "blockedUsersTitle": "Utilisateurs bloqués",
  "blockedUsersDesc": "Les utilisateurs que vous avez bloqués. Leurs designs sont masqués.",
  "blockedUsersEmpty": "Vous n’avez bloqué personne.",
  "profileBlocked": "Vous avez bloqué cet utilisateur.",
  "profileBlockedAction": "Débloquez pour revoir ses designs.",
  "errBlockGeneric": "Impossible de mettre à jour le blocage. Réessayez.",
  "errBlockedCustomCommand": "Votre demande contient des mots non autorisés.",
  "moderationAutoUnlisted": "Ce design a été retiré automatiquement du fil public par notre modération. Si c’est une erreur, contactez les administrateurs.",
  "promptLang": "French"
};
